export default () => ({
  init() {
    const headingButtons = document.querySelectorAll('.pdp-fullkit-heading');
    for (let i = 0; i < headingButtons.length; i++) {
      headingButtons[i].addEventListener('click', function () {
        if (this.classList.contains('selected')) return;
        updateFKClasses(headingButtons, this, 'selected');

        //determine if we are showing a subscription or otp
        const isOTP = this.classList.contains('otp');
        //update view of offerings depending on type of purchase
        const hideSelections = document.querySelector(`.pdp-fullkit-info${isOTP ? '.fullkit' : '.otp'}`);
        if (hideSelections && hideSelections.classList.contains('selected'))
          hideSelections.classList.remove('selected');
        const showSelections = document.querySelector(`.pdp-fullkit-info${isOTP ? '.otp' : '.fullkit'}`);
        if (showSelections && !showSelections.classList.contains('selected')) showSelections.classList.add('selected');

        const productForm = document.querySelector(
          '.product__info-wrapper .product-form__input.product-form__quantity',
        );
        const productOriginalPricing = document.querySelector('[id*="price-template"]');
        const fullkitCTA = document.querySelector('.pdp-fullkit-cta-holder');
        const fullkitPricing = document.querySelector(".pdp-fullkit-pricing");

        //update items needed to be seen or unseen depending on view
        if (!isOTP) {
          updateFKDisplay(productForm, 'none');
          updateFKDisplay(productOriginalPricing, 'none');
          updateFKDisplay(fullkitCTA, 'block');
          updateFKDisplay(fullkitPricing, 'flex');
          dynamicFKLinkChange();
        } else {
          updateFKDisplay(productForm, 'block');
          updateFKDisplay(productOriginalPricing, 'block');
          updateFKDisplay(fullkitCTA, 'none');
          updateFKDisplay(fullkitPricing, 'none');
        }

        //update images
        const selectedOption = showSelections.querySelector('.variant-option.selected');
        if (!selectedOption) return;

        const selectedOptionId = selectedOption.getAttribute('data-option-id');
        updateFKVariantImages(selectedOption, selectedOptionId);
      });
    }
    this.dynamicVariants();
    this.imageChanges();
  },
  dynamicVariants() {
    //handle clicks for all dynamic variants
    const fullkitOptions = document.querySelectorAll('.pdp-fullkit-info');
    for (let i = 0; i < fullkitOptions.length; i++) {
      const selectionVaraintSelectors = fullkitOptions[i].querySelectorAll('.variant-option');
      for (let j = 0; j < selectionVaraintSelectors.length; j++) {
        selectionVaraintSelectors[j].addEventListener('click', function () {
          //update current selections variants
          updateFKClasses(selectionVaraintSelectors, this, 'selected');

          const selectedOptionId = this.getAttribute('data-option-id');
          if (!selectedOptionId) return;
          const actualVariant = document.querySelector(
            ".product-form__input input[data-option-value-id='" + selectedOptionId + "']",
          );
          if (!actualVariant) return;
          updateVariantNames(actualVariant.getAttribute('value'));

          //adjust other card to select same variant
          var isOTP = this.closest('.pdp-fullkit-info').classList.contains('otp');

          var otherVariants = document.querySelectorAll(
            `.pdp-fullkit-info${isOTP ? '.fullkit' : '.otp'} .variant-option`,
          );
          updateFKClasses(otherVariants, otherVariants[j], 'selected');

          actualVariant.click();
            if (!isOTP) dynamicFKLinkChange();
        });
      }
    }

    function updateVariantNames(name) {
      const allVariantNames = document.querySelectorAll('.pdp-fullkit-info .dynamic-var-name');
      for (let i = 0; i < allVariantNames.length; i++) {
        allVariantNames[i].innerText = name;
      }
    }

    //updates full kit based on selected product variant on load
    function updateVariants() {
      const variantId = document.querySelector('.product-form__input input:checked');
      if (!variantId) return;
      const selectedOptionId = variantId.getAttribute('data-option-value-id');
      if (!selectedOptionId) return;
      const fullkitOptions = document.querySelectorAll('.pdp-fullkit-info');
      for (let i = 0; i < fullkitOptions.length; i++) {
        const selectionVaraintSelectors = fullkitOptions[i].querySelectorAll('.variant-option');

        const dynamicVariantSelectors = fullkitOptions[i].querySelectorAll(
          ".variant-option[data-option-id='" + selectedOptionId + "']",
        );
        for (let j = 0; j < dynamicVariantSelectors.length; j++) {
          updateFKClasses(selectionVaraintSelectors, dynamicVariantSelectors[j], 'selected');
          //updateFKVariantImages(dynamicVariantSelectors[j], variantId.getAttribute("data-option-id"));
          updateVariantNames(variantId.getAttribute('value'));
        }
      }
    }

    //updates variant on load
    updateVariants();
  },
  imageChanges() {
    let targetElement = document.querySelector('ul.product__media-list');

    let observer = new MutationObserver(() => {
      let isOTP = document.querySelector('.pdp-fullkit-info.selected').classList.contains('otp');
      let firstImage = targetElement.querySelector('li:first-child');
      if (!firstImage) return;
      const variantId = document.querySelector('.pdp-fullkit-info.fullkit .variant-option.selected');
      if (!variantId) return;

      const selectedOptionId = variantId.getAttribute('data-option-id');
      if (!selectedOptionId) return;

      //clear all images as something moves them
      const allImages = document.querySelectorAll('ul.product__media-list li[data-option-id]');
      for (let k = isOTP ? 0 : 1; k < allImages.length; k++) {
        allImages[k].removeAttribute('data-option-id');
      }

      //when not otp mark the first image with the optionid
      if (!isOTP) {
        if (firstImage.getAttribute('data-option-id') != selectedOptionId) {
          firstImage.setAttribute('data-option-id', selectedOptionId);
        }
      }
    });

    observer.observe(targetElement, { childList: true, subtree: true, attributes: true });
  },
});

function updateFKVariantImages(selectedElement, selectedOptionId) {
  var closestSelector = selectedElement.closest('.pdp-fullkit-info.selected');

  if (!closestSelector) return;
  var isOTP = closestSelector.classList.contains('otp');

  //remove other ones incase
  const allImages = document.querySelectorAll('ul.product__media-list li');
  for (let k = 0; k < allImages.length; k++) {
    allImages[k].removeAttribute('data-option-id');
  }
  //update current

  var mainImageHolder = document.querySelector('ul.product__media-list li:first-child');
  if (isOTP) {
    mainImageHolder.removeAttribute('data-option-id');
  } else {
    mainImageHolder.setAttribute('data-option-id', selectedOptionId);
  }
}

function updateFKClasses(otherElements, updateElement, className) {
  //unselect all other buttons
  for (let j = 0; j < otherElements.length; j++) {
    otherElements[j].classList.remove(className);
  }
  //mark as selected
  if (updateElement) updateElement.classList.add(className);
}

function updateFKDisplay(element, displayType) {
  if(element)
  element.style.display = displayType;
}

function dynamicFKLinkChange() {
  const fullkitCTA = document.querySelector('.pdp-fullkit-cta');
  if (!fullkitCTA) return;

  const dynamicCTALink = fullkitCTA.getAttribute('data-dynamic-link');

  //when dynamic is not set just set the link to href
  if (!dynamicCTALink) {
    const bundleCtaAnchor = fullkitCTA.querySelector('a');
    if (!bundleCtaAnchor) return;
    const newHref = bundleCtaAnchor.getAttribute('data-href');
    bundleCtaAnchor.setAttribute('href', newHref);
  }

  const currentVariant = document.querySelector('variant-selects input:checked');
  if (!currentVariant) return;

  const currentVariantId = currentVariant.getAttribute('data-option-value-id');
  if (!currentVariantId) return;

  const dynamicLinkArray = dynamicCTALink.split(',');

  let foundDynamicVariant = false;
  for (let j = 0; j < dynamicLinkArray.length; j++) {
    if (dynamicLinkArray[j].indexOf(currentVariantId) >= 0) foundDynamicVariant = dynamicLinkArray[j];
  }

    //when we found the variant via our csv options
    if (foundDynamicVariant !== false) {
        const bundleCtaAnchor = fullkitCTA.querySelector("a");

        let foundParts = foundDynamicVariant.split("|");

        if(!bundleCtaAnchor) return;
        let newHref = bundleCtaAnchor.getAttribute("data-href");
        if(foundParts.length >= 2)
            newHref = newHref.replace("%varid%", foundParts[1]);
        if(foundParts.length >= 3)
            newHref = newHref.replace("%vardiscount%", foundParts[2]);
        bundleCtaAnchor.setAttribute("href", newHref);
    }

}
